// PhoneFrame — web-port 1-op-1 van src/components/PhoneFrame.tsx
// Desktop: 390×844 device-frame met bezel + gouden gloed. Mobiel: schermvullend.
import React, { useEffect, useState } from 'react';

const FRAME_ACTIVATION_WIDTH = 600;
const CONTENT_WIDTH = 390;
const CONTENT_HEIGHT = 844;
const BEZEL = 10;
const FRAME_WIDTH = CONTENT_WIDTH + BEZEL * 2;   // 410
const FRAME_HEIGHT = CONTENT_HEIGHT + BEZEL * 2; // 864
const BEZEL_RADIUS = 48;

export function PhoneFrame({ children }) {
  const [size, setSize] = useState({ w: window.innerWidth, h: window.innerHeight });

  useEffect(() => {
    const onResize = () => setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (size.w < FRAME_ACTIVATION_WIDTH) {
    return <div data-testid="phone-frame-full" style={{ position: 'fixed', inset: 0 }}>{children}</div>;
  }

  const availableH = size.h - 32;
  const scale = Math.min(1, availableH / FRAME_HEIGHT);

  return (
    <div data-testid="phone-frame-outer" style={{
      minHeight: '100vh', background: '#050a14',
      display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
    }}>
      <div data-testid="phone-frame" style={{
        width: FRAME_WIDTH, height: FRAME_HEIGHT, borderRadius: BEZEL_RADIUS,
        background: '#0a1220', padding: BEZEL, position: 'relative',
        boxShadow: '0 24px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(196,138,58,0.18), 0 0 80px rgba(196,138,58,0.08)',
        transform: `scale(${scale})`,
      }}>
        {/* Notch */}
        <div style={{
          position: 'absolute', top: BEZEL, left: BEZEL, right: BEZEL, height: 30,
          zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none',
        }}>
          <div style={{ width: 120, height: 22, borderRadius: 14, background: '#0a1220', marginTop: 2 }} />
        </div>
        <div style={{
          width: CONTENT_WIDTH, height: CONTENT_HEIGHT, overflow: 'hidden',
          borderRadius: BEZEL_RADIUS - BEZEL, background: '#102A43', position: 'relative',
        }}>
          {children}
        </div>
      </div>
    </div>
  );
}
